// extracted by mini-css-extract-plugin
export default {"closeButton":"PopUpSaveDraft_closeButton__jZB7A","rounded":"PopUpSaveDraft_rounded__DJQGg"};